import ColumnsOnly from '@/components/blocks/columns_only/ColumnsOnly';
import FeatureHighlight from '@/components/blocks/feature/FeatureHighlight';

export default async function HighlightContent({ block, position }) {
  const {
    modular_blocks: blocks,
    text_color_picker,
    background_color_picker,
    microsite,
    animations_enabled
  } = block.highlight.reference[0];

  return (
    <>
      {blocks.map((block, index) => {
        switch (Object.keys(block)[0]) {
          case 'columns_only':
            return (
              <ColumnsOnly
                key={index}
                block={block}
                backgroundColor={background_color_picker}
                textColor={text_color_picker}
                position={position}
                microsite={microsite}
                animationsEnabled={!!animations_enabled}
              />
            );
          case 'feature':
            return (
              <FeatureHighlight
                key={index}
                block={block}
                backgroundColor={background_color_picker}
                textColor={text_color_picker}
                position={position}
              />
            );
          default:
            return <div key={index} className="empty-component"></div>;
        }
      })}
    </>
  );
}
